import { ThemeConfig } from "antd";

export const baseTokens = {
  fontFamily:
    "Geist, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  borderRadius: 6,
  fontSize: 14,
};

export const themes: Record<string, ThemeConfig> = {
  blue: {
    token: {
      ...baseTokens,
      colorPrimary: "#1677ff",
      colorTextBase: "#1f2937",
      colorBgLayout: "#f5f7fa",
      colorBgContainer: "#ffffff",
    },
    components: {
      Button: {
        controlHeight: 40,
        fontWeight: 500,
      },
      Layout: {
        headerBg: "#020617",
        siderBg: "#001529",
      },
      Menu: {
        // 🎨 Colors
        darkItemBg: "#001529",
        darkItemSelectedBg: "#1677ff",
        darkItemHoverBg: "#1d39c4",
        darkItemColor: "#cbd5e1",
      },
      Table: {
      },
      Upload: {
        pictureCardSize: 210, // 👈 height & width in px
      },
    },
  },
};
